import {
  Injectable,
  Injector,
  ApplicationRef,
  ComponentRef,
  Type,
  Inject,
  EnvironmentInjector,
  createComponent,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { take } from 'rxjs/operators';
import { MediaQueryService } from './app-wrapper/media-query.service';
import { DrawerContainerComponent } from '@shared/components/drawer/drawer.component';
import { ORIGINAL_DIALOG_SERVICE } from './tokens';

@Injectable({ providedIn: 'root' })
export class CustomDialogService {
  constructor(
    private injector: Injector,
    private envInjector: EnvironmentInjector,
    private appRef: ApplicationRef,
    private deviceService: MediaQueryService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(ORIGINAL_DIALOG_SERVICE) private originalDialogService: DialogService
  ) {}

  open(
    component: Type<any>,
    config: DynamicDialogConfig,
    parentInjector?: Injector
  ): DynamicDialogRef {
    const dialogRef = new DynamicDialogRef();

    this.deviceService.isMobile$.pipe(take(1)).subscribe((isMobile) => {
      if (isMobile) {
        const parent = parentInjector ?? this.injector;

        const componentRef = createComponent(DrawerContainerComponent, {
          environmentInjector: this.envInjector,
          elementInjector: parent,
        });

        componentRef.instance.component = component;
        componentRef.instance.config = config;
        componentRef.instance.childInjector = parent;

        componentRef.instance.onClose = (result?: any) => {
          this.closeDrawer(componentRef);
          dialogRef.close(result);
        };

        this.appRef.attachView(componentRef.hostView);
        const domElem = componentRef.location.nativeElement as HTMLElement;
        this.document.body.appendChild(domElem);
        componentRef.changeDetectorRef.detectChanges();
      } else {
        const standardRef = this.originalDialogService.open(component, config);
        standardRef.onClose.subscribe((result) => dialogRef.close(result));
      }
    });

    return dialogRef;
  }

  private closeDrawer(componentRef: ComponentRef<DrawerContainerComponent>): void {
    this.appRef.detachView(componentRef.hostView);
    componentRef.destroy();
  }
}
